export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-v3.talentmarket.io/api/v1',
  bucketBaseUrl: 'https://storage.googleapis.com/publicpicstm',
  googleClientId: '435187945467-4ph09kjjb0m96qdqmnhh6ot73qb5lmua.apps.googleusercontent.com',
  facebookAppId: '813896500729195',

  // ── Tracking (PLAN-meta-capi) — kill switch gate-ovi, v. docs/RUNBOOK-tracking-kill-switch.md ──
  metaPixelId: '2339121106893973',                // prazan = Meta Pixel init no-op (dev + kill switch L2+)
  cookiebotId: '7981cf52-370c-4241-b07a-47e5cc6da86e',                // prazan = Cookiebot uc.js se ne učitava → nema bannera ni privole (L3/L4)
  ga4MeasurementId: 'G-H81QT98PGE',
  webEventsEnabled: true,         // false = view/submit eventi se ne šalju, tm_visitor se ne piše (kill switch L4)
};